<ul
  [ngClass]="{
    'list-rating': true,
    'list-rating-2lines': displayOn2Lines
  }"
  nz-tooltip=""
  [nzTooltipPlacement]="'top'"
  [nzTooltipTitle]="getTooltip()">
  <ng-container *ngFor="let rating of getAvailableRatings()">
    <li>
      <span [ngClass]="{
      'circle': true,
      'fade-out': isLoading,
      'circle-red': isColorActive(rating, 'red'),
      'circle-orange': isColorActive(rating, 'orange'),
      'circle-yellow': isColorActive(rating, 'yellow'),
      'circle-green': isColorActive(rating, 'green')
      }"
      (mouseenter)="onRatingHover(rating)"
      (mouseleave)="onRatingLeave()"
      (click)="onClickOnRating(rating)">{{ rating }}</span>
    </li>
  </ng-container>
</ul>
